import React, { use, useEffect, useState } from 'react';
import './Loader.scss';
import { useLoading } from '../../cache/context/LoadingProvider';
import { cdnImage, LOADER_TRANSLATION, GET, LOADER_TRANSLATION_URL } from '../../helper/constants';
import useFetch from '../../cache/useFetch';
import { useLanguage } from '../../cache/context/LanguageProvider';

const Loader = () => {
  const { isLoading } = useLoading();
  const [translation, setTranslation] = useState({
    wait: "Please wait ...",
    holdOn: "Hold on!",
    loadingMessage: "We are loading the page for you"
  })
  const { languagePrefix, selectedLanguage } = useLanguage();
  const { data: translationData, refetch } = useFetch({
    url: LOADER_TRANSLATION_URL.replace('languagePrefix', languagePrefix),
    method: GET,
    initialEnabled: false,
    key: LOADER_TRANSLATION,
    cache: {
      enabled: true,
      ttl: 3600
    }
  });

  useEffect(() => {
    const cachedData = sessionStorage.getItem(`${LOADER_TRANSLATION}_${selectedLanguage}`);
    if (!cachedData) {
      refetch(true);
    } else {
      refetch(false)
    }
  }, [selectedLanguage]);

  useEffect(() => {
    if (translationData) {
      setTranslation(translationData)
    }
  }, [translationData])

  return isLoading ? <div className="loading-screen">
    <img src={`${cdnImage}assets/icons/loadingLogo.svg`} alt="loading" className='loading-img' />
        <h2 className="title">{translation?.wait}</h2>
    <span className="message">{translation?.holdOn}</span>
    <span className="message">{translation?.loadingMessage}</span>
  </div> : null;
};

export default Loader;